// Solo-page landscape "fit-width" rule.
//
// A landscape photo placed ALONE on a 1-up page is cover-fitted by default,
// which crops it (fills the tall page, loses top/bottom — or for a wide group
// shot, loses people). When this returns true the renderers fit the image to
// the page WIDTH instead: the FULL image is visible with a cream letterbox
// top + bottom, nothing cropped.
//
// Shared by ALL THREE render pipelines so they stay in render parity:
//   - editor   `pdfMirrorBox`           (AlbumEditorPage)
//   - preview  `PreviewPageCard`        (AlbumFlowPage, imports pdfMirrorBox)
//   - PDF      `computeTranslateDrawParams` (pdfGenerator)
// When true: pdfMirrorBox takes its fit-width branch and
// computeTranslateDrawParams uses min() instead of max() — the SAME box.
//
// Rule: EVERY 1-up landscape fits to width. We deliberately depend only on the
// layout + the loaded image dimensions — values all three pipelines have
// reliably — so the decision can never diverge between editor/preview/PDF. (A
// face_count gate was considered but the preview pipeline doesn't carry
// face_count, which would break parity; revisit if few-face landscapes should
// cover-fit instead, threading face_count into all three first.)
export function soloLandscapeFitWidth(
  layout: string | null | undefined,
  imgW: number | null | undefined,
  imgH: number | null | undefined,
  /** FILL page (2026-10-13, owner: « no landscape alone in half-empty space »):
   *  the composer cropped this landscape around its faces to fill the page —
   *  cover-fit like any slot. `LayoutPage.fill`, the same field in all three. */
  fill?: boolean | null,
): boolean {
  return !fill && layout === '1-up' && !!imgW && !!imgH && imgW > imgH;
}
